export default __webpack_public_path__ + "/dist/images/signup-icon.f0af410aeb51eb16b0b9ba51065f5c9a.svg";